/**
 * Reads a runtime environment variable injected via window.__ENV__.
 * Returns the value if found, or an empty string.
 */

export function getEnv(key: string): string {
  if (
    typeof window !== "undefined" &&
    (window as unknown as Record<string, unknown>).__ENV__
  ) {
    return (
      (
        (window as unknown as Record<string, unknown>).__ENV__ as Record<
          string,
          string | undefined
        >
      )[key] ?? ""
    );
  }
  return "";
}
